import React, { createContext, useContext, useState, ReactNode } from "react";

interface ReportContextType {
  isGeneratingReport: boolean;
  setIsGeneratingReport: (value: boolean) => void;
}

const ReportContext = createContext<ReportContextType | undefined>(undefined);

export const ReportProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);

  return (
    <ReportContext.Provider value={{ isGeneratingReport, setIsGeneratingReport }}>
      {children}
    </ReportContext.Provider>
  );
};

export const useReportContext = () => {
  const context = useContext(ReportContext);
  if (!context) throw new Error("useReportContext must be used within ReportProvider");
  return context;
};